<template>
  <div class="menu-container flex">
    <div @click="$router.push('/')" class="menu-chil">
      <p
        :class="[$route.name === 'homepage' ? 'p-active' : '']"
        class="c-body2 fw-600 pointer"
      >
        Home
      </p>
    </div>
    <div @click="$router.push('/About')" class="menu-chil">
      <p
        :class="[$route.name === 'About' ? 'p-active' : '']"
        class="c-body2 fw-600 pointer"
      >
        About
      </p>
    </div>
    <div @click="$router.push('/Courses')" class="menu-chil">
      <p
        :class="[$route.name === 'Courses' ? 'p-active' : '']"
        class="c-body2 fw-600 pointer"
      >
        Courses
        <i
          style="font-weight: 900 !important; font-size: 14px"
          class="el-icon-arrow-down"
        ></i>
      </p>
    </div>
    <div @click="$router.push('/Pages')" class="menu-chil">
      <p
        :class="[$route.name === 'Pages' ? 'p-active' : '']"
        class="c-body2 fw-600 pointer"
      >
        Pages
        <i
          style="font-weight: 900; font-size: 14px"
          class="el-icon-arrow-down"
        ></i>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      active: 0
    };
  },
  created() {},
  computed: {},
  methods: {},
  mounted() {},
  beforeDestroy() {}
};
</script>

<style scoped>
.menu-chil {
  margin-right: 30px;
}
.menu-chil p {
  color: #494949;
}
.menu-chil p:hover {
  color: #035ae0;
}
.p-active {
  color: #035ae0 !important;
}
@media screen and (min-width: 0px) and (max-width: 980px) {
}
</style>
